<template>
    <div>
        <span v-if="identityStatus">
            {{ identityStatus }}
        </span>
        <span v-else>-</span>
    </div>
</template>

<script>
import { compliance_mixin } from '../../../mixins.js'

export default {
    name: 'TcrStatusColumn',
    mixins: [compliance_mixin],
    props: {
        row: {
            type: Object,
            required: true,
        },
    },
    computed: {
        identityStatus() {
            return this.fixToUcFirst(this.row.identity_status)
        },
    },
}
</script>
